import { useCallback } from "react";

import { useProductDependencies } from "../../../hooks/query";
import { applyProductDependencies } from "../utils/applyProductDependencies";
import type { MaterialRowItem } from "../utils/materialLineItems";
import useEstimateContractContextManager from "./useEstimateContractContextManager";

export function useMaterialProductSelection(
    materialsByGroup: Record<string, MaterialRowItem[]>,
) {
    const { useList } = useProductDependencies();
    const { data: dependencies } = useList();
    const { patchMaterialEdits } = useEstimateContractContextManager();

    const onProductChange = useCallback(
        (
            editKey: string,
            category: string,
            productId: string | null,
        ) => {
            const patches = applyProductDependencies({
                editKey,
                category,
                selectedProductId: productId,
                dependencies,
                materialsByGroup,
            });
            patchMaterialEdits(patches);
        },
        [dependencies, materialsByGroup, patchMaterialEdits],
    );

    return { onProductChange };
}
